import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { walletState } from "../../context/walletState";
import { useConnectWallet } from "../../hooks/useTxnClient";
import { useIBC } from "../../hooks/useIBC";

const AssetDeposit = ({ setIsModalOpen, assetToken, scrtLogo }: any) => {
  const [active, setActive] = useState(false);
  const [text, setText] = useState("0");
  const [sourceBalance, setSourceBalance] = useState<any>();
  const [ibcshortaddress, setibcshortaddress] = useState<any>();
  const { address, mediumAddress } = useRecoilValue(walletState);
  const connectWallet = useConnectWallet();

  const {
    getTokenSourceBalance,
    doToScrtTransfer,
    getTokenSourceAddressShort,
  } = useIBC();

  const handleDeposit = async () => {
    const transferResponse = await doToScrtTransfer(
      assetToken.display_denom,
      text
    );
  };

  useEffect(() => {
    const bala = async () => {
      const sBalance = await getTokenSourceBalance(assetToken.display_denom);
      setSourceBalance(sBalance);

      const address = await getTokenSourceAddressShort(
        assetToken.display_denom
      );
      setibcshortaddress(address);
    };
    bala();
  }, [assetToken]);

  return (
    <>
      <div className="asset-withdraw">
        <div className="modal-header">
          <div className="asset-withdraw-header">
            Deposit {assetToken.display_denom}
          </div>
          <div className="modal-close-wrapper">
            <span
              onClick={() => setIsModalOpen(false)}
              className="material-symbols-outlined modal-close-button"
            >
              close
            </span>
          </div>
        </div>
        <hr className="asset-hr-line"></hr>

        <div className="asset-wthdraw-img-container">
          <div
            className="asset-wthdraw-img-div"
            onClick={() => setActive(true)}
          >
            <img className="coin-display" src={assetToken.logo_URIs.png} />
            from {assetToken.display_denom}
          </div>
          <div className="assetMove"></div>
          <div
            className="asset-wthdraw-img-div"
            onClick={() => setActive(true)}
          >
            <img className="coin-display" src={scrtLogo} />
            to SCRT
          </div>
        </div>
        <div className="withdraw-address">
          <div className="withdraw-address-left">
            {ibcshortaddress ? ibcshortaddress : "-"}
          </div>
          <div className="withdraw-address-right">
            {mediumAddress ? mediumAddress : "-"}
          </div>
        </div>

        <div className="deposit-input">
          <div className="deposit-amount-header">
            <p>Select Amount</p>
            <span>
              Available on {assetToken.display_denom}:{" "}
              <div
                className="ibc-balance-amount"
                onClick={() => {
                  setText(sourceBalance ? sourceBalance : "0");
                }}
              >
                {sourceBalance ? sourceBalance : "-"} {assetToken.display_denom}{" "}
              </div>
            </span>
          </div>
          <div className="deposit-amount">
            <input
              type="number"
              // placeholder="Enter the token amount"
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </div>
        </div>

        <div className="deposit-time">
          <div>Estimated time</div>
          <div>20 seconds</div>
        </div>

        <div
          className={`asset-withdraw-btn common-button ${
            sourceBalance && address
              ? sourceBalance < text || text <= "0"
                ? "disabled-button"
                : ""
              : ""
          }`}
          onClick={
            address
              ? sourceBalance >= text && text > "0"
                ? handleDeposit
                : () => {}
              : connectWallet
          }
        >
          {address
            ? !(text <= "0")
              ? !(sourceBalance < text)
                ? `Deposit ${assetToken.display_denom}`
                : "Insufficient Balance"
              : "Invalid Input"
            : "Connect Wallet"}
        </div>
      </div>
    </>
  );
};

export default AssetDeposit;
